export default "__VITE_ASSET__cxJIOp4I__"